// extracted by mini-css-extract-plugin
export default {"pageContainer":"AppLayout_pageContainer__exERA","mainContent":"AppLayout_mainContent__zPGlX"};